import { render, staticRenderFns } from "./IdentityValidation.vue?vue&type=template&id=5b97ff36&"
import script from "./IdentityValidation.vue?vue&type=script&lang=js&"
export * from "./IdentityValidation.vue?vue&type=script&lang=js&"
import style0 from "./IdentityValidation.vue?vue&type=style&index=0&id=5b97ff36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports